import dynamic from 'next/dynamic'

import { Grid } from '@mui/material'

import type { FC, Key } from 'react'
import type { UnpackedSanityArticle, UnpackedSanityPage } from '@/lib/queries/sanityQueryStrings'

const SanityHeroBanner = dynamic(() =>
  import('@/components/SanityComponent/SanityHeroBanner').then((mod) => mod.SanityHeroBanner)
)

const SanityProductsList = dynamic(() =>
  import('@/components/SanityComponent/SanityProductsList').then((mod) => mod.SanityProductsList)
)

const SanityBlockContent = dynamic(() =>
  import('@/components/SanityComponent/SanityBlockContent').then((mod) => mod.SanityBlockContent)
)

const TextColumnImagesBanner = dynamic(() =>
  import('@/components/SanityComponent/TextColumnImagesBanner').then((mod) => mod.TextColumnImagesBanner)
)

const SanityHubSpotFormComponent = dynamic(() =>
  import('@/components/SanityComponent/SanityHubSpotForm').then((mod) => mod.SanityHubSpotForm)
)

interface SanityComponentsProps {
  sanityComponent: NonNullable<UnpackedSanityPage['content'] | UnpackedSanityArticle['content']>[number]
  index: Key
}

export const ContentSanityComponent: FC<SanityComponentsProps> = ({ sanityComponent, index }) => {
  switch (sanityComponent._type) {
    case 'heroBannerCarousel':
      return (
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          lg={8}
          key={index}
          pr={{
            xs: 0,
            lg: 3,
          }}
          sx={{
            backgroundColor: 'background.body',
          }}
        >
          <SanityHeroBanner sanityComponent={sanityComponent} />
        </Grid>
      )
    case 'productsList':
      return (
        <Grid
          item
          xs={12}
          pr={{
            xs: 0,
            lg: 3,
          }}
          key={index}
          sx={{ backgroundColor: 'background.body' }}
        >
          <SanityProductsList sanityComponent={sanityComponent} />
        </Grid>
      )
    case 'blockContentComponent':
      return (
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          lg={8}
          pr={{
            xs: 0,
            lg: 3,
          }}
          key={index}
          sx={{ backgroundColor: 'background.body' }}
        >
          <SanityBlockContent sanityComponent={sanityComponent} />
        </Grid>
      )
    case 'textColumnImagesBanner':
      return (
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          lg={8}
          pr={{
            xs: 0,
            lg: 3,
          }}
          key={index}
          sx={{ backgroundColor: 'background.body' }}
        >
          <TextColumnImagesBanner sanityComponent={sanityComponent} />
        </Grid>
      )
    case 'hubspotForm':
      return (
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          lg={8}
          pr={{
            xs: 0,
            lg: 3,
          }}
          key={index}
          sx={{ backgroundColor: 'background.body' }}
        >
          <SanityHubSpotFormComponent sanityComponent={sanityComponent} />
        </Grid>
      )
    default:
      return null
  }
}
